import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Light Icon Style 02 - Light Mode (Material Symbol)
 * A sun-like icon for light devices
 * - isOn = true: 橙黃色實心太陽 (FILL: 1)
 * - isOn = false: 灰色空心太陽 (FILL: 0)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:light_mode
 */
export const Style02_LightMode: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-amber-500' : 'text-slate-400';
  
  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      light_mode
    </span>
  );
};

export default Style02_LightMode;
